import React, { useState, useEffect } from "react";
import "./ProfileModal.css";
import { useProfile } from "../context/ProfileContext";
import { useScrollLock } from "../hooks/useScrollLock";
import { useApi } from "../utils/Api";
import OrderHistory from "./OrderHistory";

const ProfileModal = ({ user, onLogout, onUpdate }) => {
  const {
    isProfileOpen,
    activeTab,
    closeProfile,
    setActiveTab: setContextTab,
  } = useProfile();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { apiFetch } = useApi();

  useScrollLock(isProfileOpen);


  // Update form fields when user changes
  useEffect(() => {
    setFirstName(user?.first_name || "");
    setLastName(user?.last_name || "");
    setPhone(user?.phone || "");
    setEmail(user?.email || "");
  }, [user]);

  const handleSave = async () => {
    if (!user?.id) return;

    // Validation
    if (!firstName.trim() || !lastName.trim()) {
      setError("Both first name and last name are required.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const data = await apiFetch("update-profile", {
        user_id: user.id,
        first_name: firstName.trim(),
        last_name: lastName.trim(),
        phone: phone.trim(),
        email: email.trim(),
      });

      if (data.status === "success") {
        onUpdate({
          ...user,
          first_name: firstName.trim(),
          last_name: lastName.trim(),
          phone: phone.trim(),
          email: email.trim(),
        });
        closeProfile();
      } else {
        if (data.message?.includes("Phone")) {
          setError("Phone number is already in use.");
        } else if (data.message?.includes("Email")) {
          setError("Email is already in use.");
        } else {
          setError(data.message || "Failed to update profile.");
        }
      }
    } catch (err) {
      console.error(err);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!isProfileOpen || !user) return null;

  return (
    <div className="profile-modal-overlay" onClick={closeProfile}>
      <div className="profile-modal" onClick={(e) => e.stopPropagation()}>
        <span className="profile-modal-close" onClick={closeProfile}>
          &times;
        </span>

        {/* Tabs */}
        <div className="profile-tabs">
          <button
            className={activeTab === "profile" ? "active" : ""}
            onClick={() => setContextTab("profile")}
          >
            Profile
          </button>
          <button
            className={activeTab === "orders" ? "active" : ""}
            onClick={() => setContextTab("orders")}
          >
            Order History
          </button>
        </div>

        {/* PROFILE TAB */}
        {activeTab === "profile" && (
          <>
            <label>First Name</label>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />

            <label>Last Name</label>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />

            <label>Phone</label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />

            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            {error && <p className="auth-error">{error}</p>}

            <div className="profile-modal-actions">
              <button onClick={handleSave} disabled={loading}>
                {loading ? <span className="spinner"></span> : "Save"}
              </button>
              <button className="logout-btn" onClick={onLogout}>
                Logout
              </button>
            </div>
          </>
        )}

        {activeTab === "orders" && (
          <OrderHistory user={user} closeProfile={closeProfile} />
        )}
      </div>
    </div>
  );
};

export default ProfileModal;
